import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";


const questionnaireGM: QuestionnaireFlowType = {
    id: FindingAreasEnum.GlobalMobility,
    name: getFindingAreaDisplayText(FindingAreasEnum.GlobalMobility),
    questions: [
        {
            id: `${FindingAreasEnum.GlobalMobility}:Q1`,
            text: "Do you have employees who travel from overseas to perform work for a UK entity?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.GlobalMobility}:Q2a`,
                no: ConclusionKeys.Green
            }
        },
        {
            id: `${FindingAreasEnum.GlobalMobility}:Q2a`,
            text: "Is any reporting/payment made in respect of income tax (and NIC where relevant) in the UK in relation to these employees?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: `${FindingAreasEnum.GlobalMobility}:Q3b`
            }
        },
        {
            id: `${FindingAreasEnum.GlobalMobility}:Q3b`,
            text: "Do you have a Short Term Business Visitor Agreement (\"STBVA\") in place?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Red
            }
        }
    ]
}

export default questionnaireGM;